import React from "react";
import { WebIM } from "../../components/WebIM";
import styles from "./index.module.scss";
import { useHistory } from "react-router-dom";

const Chat = () => {
    const history = useHistory();

    function onGotoDetail(sessionId: string) {
        history.push(`/chat/detail/${sessionId}`);
    }

    return (
        <div className={styles.wrapper}>
            <WebIM.FullIM onGotoDetail={onGotoDetail} />
        </div>
    );
};

export default Chat;
